import React, { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import "./HangtenBearSupport.css";

function answerFor(message, pathname) {
  const text = String(message || "").toLowerCase();
  if (text.includes("barcode") || text.includes("scan") || text.includes("စကန်")) {
    return "Barcode အပြည့် (Code-Colour-Size) ကို တိုက်ရိုက် scan ဖတ်နိုင်ပါတယ်။ Code ပဲပါရင် Colour နဲ့ Size ကို ရွေးပြီး Confirm scan လုပ်ပါ။ စာရင်းထဲမပါတဲ့ Code၊ Colour၊ Size နဲ့ ပိုဖတ်တာကို စနစ်က တားပါမယ်။";
  }
  if (text.includes("transfer") || text.includes("လွှဲ") || text.includes("ပို့")) {
    return "Transfer လမ်းကြောင်းက ဒီလိုပါ — WS → Shop မှာ Warehouse က Save → Product Transfer → scan ပြည့်မှ Transfer Now → Shop POS မှာ scan → Accept လုပ်ပါ။ Shop → Shop မှာ A4 Plan ID/version နဲ့ POS မှာဖွင့်ပြီး source scan ပြည့်မှ Send၊ လက်ခံဆိုင်က scan ပြီး Accept လုပ်ပါ။";
  }
  if (text.includes("inventory") || text.includes("stock") || text.includes("လက်ကျန်")) {
    return "Inventory မှာ ဆိုင်အလိုက် Code / Colour / Size / Qty ကိုကြည့်နိုင်ပါတယ်။ Pending transfer တွေကို ပြန်ပို့လို့မရအောင် reserve ထားပြီး လက်ခံပြီးမှ destination stock ထဲ ဝင်ပါမယ်။";
  }
  if (text.includes("aymht") || text.includes("warehouse") || text.includes("ဂိုဒေါင်")) {
    return "AYMHT က Hangten main warehouse ဖြစ်ပါတယ်။ Warehouse stock ကနေ ဆိုင်လိုအပ်ချက်အလိုက် အကြံပြု transfer ထုတ်ပေးပြီး WS staff က စာရင်းကို စစ်၊ ပြင်၊ scan ပြီးမှ ပို့နိုင်ပါတယ်။";
  }
  if (text.includes("help") || text.includes("ကူညီ") || text.includes("ဘယ်လို")) {
    return `ဒီ page (${pathname}) မှာ ကူညီနိုင်ပါတယ်။ Transfer, Barcode scan, Inventory လက်ကျန် ဒါမှမဟုတ် Shop POS လက်ခံပုံကို မေးပါ။`;
  }
  return "နားလည်ပါတယ်။ Transfer, Barcode scan, Inventory လက်ကျန်၊ AYMHT warehouse ဒါမှမဟုတ် Shop POS လက်ခံမှုထဲက ဘာကို သိချင်တာလဲ ရေးပေးပါ။";
}

export default function HangtenBearSupport() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState("");
  const [messages, setMessages] = useState([
    { from: "bear", text: "မင်္ဂလာပါ။ Hangten ERP အတွက် ဘာကူညီပေးရမလဲ?" },
  ]);
  const quick = useMemo(() => ["Transfer ဘယ်လိုလုပ်ရမလဲ?", "Barcode scan စည်းမျဉ်း", "Inventory လက်ကျန်"], []);

  function send(value = draft) {
    const text = String(value || "").trim();
    if (!text) return;
    setMessages(previous => [...previous, { from: "user", text }, { from: "bear", text: answerFor(text, pathname) }]);
    setDraft("");
  }

  return <div className={`hangtenSupport${open ? " is-open" : ""}`}>
    {open && <section className="hangtenSupport__panel" aria-label="Hangten support assistant">
      <header className="hangtenSupport__header">
        <div className="hangtenSupport__avatar" aria-hidden="true">🐻</div>
        <div><strong>Hangten Support</strong><span>ERP ကူညီပေးမယ့် ဝက်ဝံလေး</span></div>
        <button type="button" aria-label="Close support" onClick={() => setOpen(false)}>×</button>
      </header>
      <div className="hangtenSupport__messages" aria-live="polite">
        {messages.map((item, index) => <div key={`${index}-${item.from}`} className={`hangtenSupport__message ${item.from}`}>{item.text}</div>)}
      </div>
      <div className="hangtenSupport__quick">{quick.map(item => <button type="button" key={item} onClick={() => send(item)}>{item}</button>)}</div>
      <form className="hangtenSupport__form" onSubmit={event => { event.preventDefault(); send(); }}>
        <input value={draft} onChange={event => setDraft(event.target.value)} placeholder="မေးချင်တာ ရေးပါ..." aria-label="Support message" />
        <button type="submit" disabled={!draft.trim()}>ပို့</button>
      </form>
    </section>}
    <button type="button" className="hangtenSupport__launcher" aria-label={open ? "Close Hangten support" : "Open Hangten support"} aria-expanded={open} onClick={() => setOpen(value => !value)}>
      <span className="hangtenSupport__bear" aria-hidden="true">🐻</span><span className="hangtenSupport__pulse" />
    </button>
  </div>;
}
